export default __webpack_public_path__ + "static/media/sneakers-nft.a31112b4.svg";